import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import ReactToPrint from "react-to-print";

interface PropsCR {}

const CashRecipt: React.FC<PropsCR> = ({}) => {
  const history = useHistory();
  const { customerVisitId } = useParams<{ customerVisitId: string }>();
  const [grossAmount, setGrossAmount] = useState<any>(0);
  const [discountAmount, setDiscountAmount] = useState<any>(0);
  const [paidAmount, setPaidAmount] = useState<any>(0);
  const [totalDueAmount, setTotalDueAmount] = useState<any>(0);
  const [testBookingData, setTestBookingData] = useState<any>([]);
  let prerequisitesLoaded = false;
  const price_in_words = (price: any) => {
    let sglDigit = [
        "Zero",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
      ],
      dblDigit = [
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ],
      tensPlace = [
        "",
        "Ten",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ],
      handle_tens = function (dgt: number, prevDgt: number) {
        return 0 === dgt
          ? ""
          : " " + (1 === dgt ? dblDigit[prevDgt] : tensPlace[dgt]);
      },
      handle_utlc = function (dgt: number, nxtDgt: number, denom: string) {
        return (
          (0 != dgt && 1 != nxtDgt ? " " + sglDigit[dgt] : "") +
          (0 != nxtDgt || dgt > 0 ? " " + denom : "")
        );
      };

    let str = "";
    let digitIdx: number = 0;
    let digit: number;
    let nxtDigit: number = 0;
    let words = [];
    if (((price += ""), isNaN(parseInt(price)))) str = "";
    else if (parseInt(price) > 0 && price.length <= 10) {
      for (digitIdx = price.length - 1; digitIdx >= 0; digitIdx--)
        switch (
          ((digit = price[digitIdx] - 0),
          (nxtDigit = digitIdx > 0 ? price[digitIdx - 1] - 0 : 0),
          price.length - digitIdx - 1)
        ) {
          case 0:
            words.push(handle_utlc(digit, nxtDigit, ""));
            break;
          case 1:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 2:
            words.push(
              0 != digit
                ? " " +
                    sglDigit[digit] +
                    " Hundred" +
                    (0 != price[digitIdx + 1] && 0 != price[digitIdx + 2]
                      ? " and"
                      : "")
                : ""
            );
            break;
          case 3:
            words.push(handle_utlc(digit, nxtDigit, "Thousand"));
            break;
          case 4:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 5:
            words.push(handle_utlc(digit, nxtDigit, "Lakh"));
            break;
          case 6:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 7:
            words.push(handle_utlc(digit, nxtDigit, "Crore"));
            break;
          case 8:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 9:
            words.push(
              0 != digit
                ? " " +
                    sglDigit[digit] +
                    " Hundred" +
                    (0 != price[digitIdx + 1] || 0 != price[digitIdx + 2]
                      ? " and"
                      : " Crore")
                : ""
            );
        }
      str = words.reverse().join("");
    } else str = "";
    return str;
  };

  const componentRef = useRef<any>(null);
  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const reactToPrintTrigger = React.useCallback(() => {
    return <button>Print Receipt</button>;
  }, []);

  const handleBack = () => {
    localStorage.removeItem("addonPrice");
    history.goBack();
  };

  return (
    <div
      style={{
        margin: "50px auto",
      }}
    >
      <button
        style={{
          width: "120px",
          borderRadius: "5%",
          backgroundColor: "#ef5350",
          color: "white",
        }}
        onClick={handleBack}
      >
        {"<< Go Back"}
      </button>
      <ReactToPrint
        content={reactToPrintContent}
        trigger={reactToPrintTrigger}
      />
      <div
        style={{
          width: "842px",
          border: "1px solid grey",
          margin: 20,
        }}
      >
        <div
          ref={componentRef}
          style={{
            margin: 20,
          }}
        >
          <div>
            <meta charSet="UTF-8" style={{ fontFamily: "sans-serif" }} />
            <meta
              name="viewport"
              // content="width=device-width, initial-scale=1.0"
              style={{ fontFamily: "sans-serif" }}
            />
            <title style={{ fontFamily: "sans-serif" }}>Invoice</title>
            <div
              className="invoiceContainer"
              style={{
                fontFamily: "sans-serif",
                marginInline: "5vw",
                marginTop: 0,
              }}
            >
              <div id="divToPrint" style={{ fontFamily: "sans-serif" }}>
                <hr
                  className="headerLine"
                  style={{
                    border: "5px solid #47cacc",
                    fontFamily: "sans-serif",
                    width: "100%",
                  }}
                />
                <div
                  className="logoContainer"
                  style={{
                    alignItems: "center",
                    marginTop: "2rem",
                    paddingLeft: "2rem",
                    paddingRight: "2rem",
                  }}
                >
                  <img
                    className="invoiceImage"
                    src="https://redcliffelabsbackend.s3.amazonaws.com/media/gallary-file/None/c733a81f-0fb6-4fbf-9daf-1969c852d698.png"
                    style={{ fontFamily: "sans-serif", height: "40px" }}
                  />
                  <span
                    className="invoiceHeading"
                    style={{
                      float: "right",
                      fontFamily: "sans-serif",
                      fontSize: "30px",
                      fontWeight: 700,
                    }}
                  >
                    Invoice
                  </span>
                </div>
                <hr style={{ fontFamily: "sans-serif" }} />
                <div className="invoiceGrid" style={{ marginTop: "-8px" }}>
                  <div
                    className="invoiceGridItem"
                    style={{
                      float: "left",
                      width: "18%",
                      border: "2px solid rgba(214, 209, 209, 0.8)",
                      borderBottom: "none",
                      borderLeft: "none",
                      borderTop: "none",
                      fontFamily: "sans-serif",
                      fontSize: "14px",
                      fontWeight: 400,
                      paddingTop: "6px",
                      textAlign: "center",
                    }}
                  >
                    INVOICE NO.
                    <div
                      className="invoiceGridValue"
                      style={{
                        fontFamily: "sans-serif",
                        fontSize: "16px",
                        fontWeight: 600,
                        padding: "1rem",
                      }}
                    >
                      2022188390
                    </div>
                  </div>
                  <div
                    className="invoiceGridItem"
                    style={{
                      float: "left",
                      width: "18%",
                      border: "2px solid rgba(214, 209, 209, 0.8)",
                      borderBottom: "none",
                      borderLeft: "none",
                      borderTop: "none",
                      fontFamily: "sans-serif",
                      fontSize: "14px",
                      fontWeight: 400,
                      paddingTop: "6px",
                      textAlign: "center",
                    }}
                  >
                    INVOICE DATE
                    <div
                      className="invoiceGridValue"
                      style={{
                        fontFamily: "sans-serif",
                        fontSize: "16px",
                        fontWeight: 600,
                        padding: "1rem",
                      }}
                    >
                      Jan 29, 2022
                    </div>
                  </div>
                  <div
                    className="invoiceGridItem"
                    style={{
                      float: "left",
                      width: "18%",
                      border: "2px solid rgba(214, 209, 209, 0.8)",
                      borderBottom: "none",
                      borderLeft: "none",
                      borderTop: "none",
                      fontFamily: "sans-serif",
                      fontSize: "14px",
                      fontWeight: 400,
                      paddingTop: "6px",
                      textAlign: "center",
                    }}
                  >
                    BOOKING ID
                    <div
                      className="invoiceGridValue"
                      style={{
                        fontFamily: "sans-serif",
                        fontSize: "16px",
                        fontWeight: 600,
                        padding: "1rem",
                      }}
                    >
                      188390
                    </div>
                  </div>
                  <div
                    className="invoiceGridItem"
                    style={{
                      float: "left",
                      width: "25%",
                      border: "2px solid rgba(214, 209, 209, 0.8)",
                      borderBottom: "none",
                      borderLeft: "none",
                      borderTop: "none",
                      fontFamily: "sans-serif",
                      fontSize: "14px",
                      fontWeight: 400,
                      paddingTop: "6px",
                      textAlign: "center",
                    }}
                  >
                    <span style={{ fontFamily: "sans-serif" }}>
                      SAMPLE COLLECTION DATE
                    </span>
                    <div
                      className="invoiceGridValue"
                      style={{
                        fontFamily: "sans-serif",
                        fontSize: "16px",
                        fontWeight: 600,
                        padding: "1rem",
                      }}
                    >
                      Jan 01, 2022
                    </div>
                  </div>
                  <div
                    className="invoiceGridItem invoiceGridItemLast"
                    style={{
                      float: "left",
                      width: "18%",
                      border: "2px solid rgba(214, 209, 209, 0.8)",
                      borderBottom: "none",
                      borderLeft: "none",
                      borderRight: "none",
                      borderTop: "none",
                      fontFamily: "sans-serif",
                      fontSize: "14px",
                      fontWeight: 400,
                      paddingTop: "6px",
                      textAlign: "center",
                    }}
                  >
                    SAC CODE
                    <div
                      className="invoiceGridValue"
                      style={{
                        fontFamily: "sans-serif",
                        fontSize: "16px",
                        fontWeight: 600,
                        padding: "1rem",
                      }}
                    >
                      999316
                    </div>
                  </div>
                </div>
                <hr style={{ clear: "left", fontFamily: "sans-serif" }} />
                <div
                  className="invoiceBill"
                  style={{
                    clear: "left",
                    backgroundColor: "#f2fcff",
                    fontFamily: "sans-serif",
                    paddingTop: "2rem",
                    paddingBottom: "2rem",
                    paddingLeft: "1rem",
                    paddingRight: "1rem",
                    height: "10rem",
                  }}
                >
                  <div
                    className="billForm"
                    style={{
                      float: "left",
                      fontFamily: "sans-serif",
                      fontSize: "14px",
                      width: "50%",
                    }}
                  >
                    <div
                      className="billFormHeading"
                      style={{
                        color: "#11406b",
                        fontFamily: "sans-serif",
                        fontWeight: 600,
                        paddingBottom: "1.5rem",
                      }}
                    >
                      BILL FROM
                    </div>
                    <div
                      className="billFormContent"
                      style={{ fontFamily: "sans-serif", padding: "0.5rem" }}
                    >
                      CIN Number:-{" "}
                      <strong style={{ fontFamily: "sans-serif" }}>
                        U85100UP2021PTC140992
                      </strong>
                    </div>
                    <div
                      className="billFormContent"
                      style={{ fontFamily: "sans-serif", padding: "0.5rem" }}
                    >
                      <strong style={{ fontFamily: "sans-serif" }}>
                        Redcliffe Lifetech Pvt Ltd
                      </strong>
                    </div>
                    <div
                      className="billFormContent"
                      style={{ fontFamily: "sans-serif", padding: "0.5rem" }}
                    >
                      Unit No. 1 To 8 M-Wing, Tex Centre CHS, Saki Vihar Road
                      ChandivaIi, Andheri East Mumbai, Mumbai, Maharashtra
                      400072
                    </div>
                  </div>
                  <div
                    className="billForm"
                    style={{
                      float: "right",
                      fontFamily: "sans-serif",
                      fontSize: "14px",
                    }}
                  >
                    <div
                      className="billFormHeading"
                      style={{
                        color: "#11406b",
                        fontFamily: "sans-serif",
                        fontWeight: 600,
                        paddingBottom: "1.5rem",
                      }}
                    >
                      CUSTOMER DETAILS
                    </div>
                    <div style={{ fontFamily: "sans-serif" }}>
                      <strong style={{ fontFamily: "sans-serif" }}>
                        suraj das
                      </strong>
                    </div>
                    <div style={{ fontFamily: "sans-serif" }}>
                      Govindpuri ,Delhi - 110019
                    </div>
                  </div>
                </div>
                <hr style={{ clear: "left", fontFamily: "sans-serif" }} />
                <div style={{ fontFamily: "sans-serif" }}>
                  <div
                    className="invoiceTestDescHead"
                    style={{
                      backgroundColor: "#f4f4f4",
                      fontFamily: "sans-serif",
                      fontSize: "16px",
                      fontWeight: 600,
                      marginTop: "2rem",
                      padding: "1rem",
                      paddingBottom: "2rem",
                    }}
                  >
                    <div style={{ float: "left", fontFamily: "sans-serif" }}>
                      TEST DESCRIPTION
                    </div>
                    <div style={{ float: "right", fontFamily: "sans-serif" }}>
                      AMOUNT
                    </div>
                  </div>
                  <div
                    className="billDetailsName"
                    style={{
                      fontFamily: "sans-serif",
                      fontSize: "15px",
                      fontWeight: 600,
                      padding: "1rem",
                    }}
                  >
                    <p
                      style={{
                        color: "#11406b",
                        fontFamily: "sans-serif",
                        paddingBottom: "1rem",
                      }}
                    >
                      Suraj Das
                    </p>
                    <hr style={{ fontFamily: "sans-serif" }} />
                  </div>

                  <div
                    className="billDetailsTests"
                    style={{
                      color: "black !important",
                      fontFamily: "sans-serif",
                      fontSize: "16px",
                      paddingRight: "1rem",
                      paddingLeft: "2rem !important",
                    }}
                  >
                    Smart Full Body Checkup
                    <br />
                    code: HE101
                    <div style={{ float: "right", fontFamily: "sans-serif" }}>
                      <strong style={{ fontFamily: "sans-serif" }}>
                        ₹699.0
                      </strong>
                    </div>
                  </div>

                  <div
                    className="invoiceTestDescTotal"
                    style={{
                      backgroundColor: "#fbfbfb",
                      fontFamily: "sans-serif",
                      fontSize: "16px",
                      marginTop: "1rem",
                      padding: "1rem",
                      paddingBottom: "2rem",
                    }}
                  >
                    <div style={{ float: "left", fontFamily: "sans-serif" }}>
                      Total Amount
                    </div>
                    <div style={{ float: "right", fontFamily: "sans-serif" }}>
                      ₹699
                    </div>
                  </div>
                  <div
                    className="invoiceTestDescTotal"
                    style={{
                      backgroundColor: "#fbfbfb",
                      fontFamily: "sans-serif",
                      fontSize: "16px",
                      padding: "1rem",
                      paddingBottom: "2rem",
                    }}
                  >
                    <div style={{ float: "left", fontFamily: "sans-serif" }}>
                      Discount
                    </div>
                    <div style={{ float: "right", fontFamily: "sans-serif" }}>
                      ₹34
                    </div>
                  </div>
                  <hr style={{ fontFamily: "sans-serif" }} />
                  <div
                    className="invoiceTestDescTotal1"
                    style={{
                      fontFamily: "sans-serif",
                      fontSize: "16px",
                      fontWeight: 600,
                      padding: "1rem",
                      paddingBottom: "2rem",
                    }}
                  >
                    <div style={{ float: "left", fontFamily: "sans-serif" }}>
                      Grand Total
                    </div>
                    <div style={{ float: "right", fontFamily: "sans-serif" }}>
                      ₹664
                    </div>
                  </div>
                  <div
                    className="invoiceTestDescTotal2"
                    style={{
                      backgroundColor: "#f4f4f4",
                      fontFamily: "sans-serif",
                      fontSize: "16px",
                      fontWeight: 600,
                      padding: "1rem",
                      paddingBottom: "2rem",
                    }}
                  >
                    <div style={{ float: "left", fontFamily: "sans-serif" }}>
                      Paid Amount
                    </div>
                    <div style={{ float: "right", fontFamily: "sans-serif" }}>
                      ₹664
                    </div>
                  </div>
                </div>
                <div
                  className="invoiceSummary"
                  style={{
                    fontFamily: "sans-serif",
                    fontSize: "13px",
                    lineHeight: "1.4",
                    marginTop: "3rem",
                    paddingLeft: "1rem",
                    paddingRight: "1rem",
                    marginBottom: "11rem",
                  }}
                >
                  <div style={{ float: "left", fontFamily: "sans-serif" }}>
                    <strong style={{ fontFamily: "sans-serif" }}>
                      Amount Chargable (in words)
                    </strong>
                    <div style={{ fontFamily: "sans-serif" }}>
                      <i style={{ fontFamily: "sans-serif" }}>
                        Rupees
                        {price_in_words(664)}
                        Only
                      </i>
                    </div>
                    <div
                      className="blueColor"
                      style={{
                        color: "#11406b",
                        fontFamily: "sans-serif",
                        fontSize: "15px",
                      }}
                    >
                      Company's PAN No.{" "}
                      <span style={{ fontFamily: "sans-serif" }}>
                        AAKCR7631M
                      </span>
                    </div>
                  </div>
                  <div
                    className="paymentSummary"
                    style={{
                      float: "right",
                      fontFamily: "sans-serif",
                      textAlign: "end",
                    }}
                  >
                    <strong style={{ fontFamily: "sans-serif" }}>
                      Payment Mode Summary
                    </strong>
                    <table
                      className="invoiceSummaryTable"
                      style={{
                        borderCollapse: "collapse",
                        fontFamily: "sans-serif",
                        fontSize: "12px",
                        marginTop: "1rem",
                        textAlign: "left",
                        width: "100%",
                      }}
                    >
                      <tbody>
                        <tr
                          style={{
                            backgroundColor: "#f1f1f1",
                            fontFamily: "sans-serif",
                          }}
                        >
                          <td
                            style={{
                              fontFamily: "sans-serif",
                              padding: ".6rem",
                              paddingRight: "1.6rem",
                            }}
                          >
                            Payment Date
                          </td>
                          <td
                            style={{
                              fontFamily: "sans-serif",
                              padding: ".6rem",
                              paddingRight: "1.6rem",
                            }}
                          >
                            Payment Mode
                          </td>
                          <td
                            style={{
                              fontFamily: "sans-serif",
                              padding: ".6rem",
                            }}
                          >
                            Amount
                          </td>
                        </tr>
                        <tr
                          style={{
                            backgroundColor: "#f9f9f9",
                            fontFamily: "sans-serif",
                          }}
                        >
                          <td
                            style={{
                              fontFamily: "sans-serif",
                              padding: ".6rem",
                              paddingRight: "1.6rem",
                            }}
                          >
                            Jan 01, 2022
                          </td>
                          <td
                            style={{
                              fontFamily: "sans-serif",
                              padding: ".6rem",
                              paddingRight: "1.6rem",
                            }}
                          >
                            cash
                          </td>
                          <td
                            style={{
                              fontFamily: "sans-serif",
                              padding: ".6rem",
                            }}
                          >
                            ₹664
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <hr style={{ fontFamily: "sans-serif" }} />
                  </div>
                </div>
                <div
                  className="invoiceNotes"
                  style={{
                    clear: "left",
                    backgroundColor: "#fbfbfb",
                    fontFamily: "sans-serif",
                    fontSize: "12px",
                    lineHeight: "1.4",
                    marginBottom: "1rem",
                    marginTop: "1.6rem",
                    padding: ".5rem",
                  }}
                >
                  <strong style={{ fontFamily: "sans-serif" }}>
                    Important Notes:
                  </strong>
                  <ul style={{ fontFamily: "sans-serif" }}>
                    <li style={{ fontFamily: "sans-serif" }}>
                      This invoice can be used for tax exemption under section
                      80-D (Preventive Health Checkup)
                    </li>
                    <li style={{ fontFamily: "sans-serif" }}>
                      Reports sent on registered mail ID according to the
                      respective TAT and can also be downloaded through
                      Redcliffe Labs Application
                    </li>
                    <li style={{ fontFamily: "sans-serif" }}>
                      All dispute / claims concerning to reports are subject to
                      the courts of Delhi only
                    </li>
                    <li style={{ fontFamily: "sans-serif" }}>
                      Redcliffe Labs assumes no liability towards any delays
                      beyond its control
                    </li>
                    <li style={{ fontFamily: "sans-serif" }}>
                      It is recommended that you consult your treating
                      Doctor/Physician before choosing any treatment based on
                      your report
                    </li>
                    <li style={{ fontFamily: "sans-serif" }}>
                      Maximum liability of the Company shall not exceed the
                      amount charged by the Company for the services availed
                    </li>
                    <li style={{ fontFamily: "sans-serif" }}>
                      This is a computer generated receipt and does not require
                      signature/stamp
                    </li>
                  </ul>
                </div>
                <div
                  className="invoiceFooter"
                  style={{
                    backgroundColor: "#47cacc",
                    color: "#0a2d4e",
                    fontFamily: "sans-serif",
                    fontSize: "16px",
                    padding: "1.8rem",
                    paddingBottom: "2.9rem",
                  }}
                >
                  <div
                    className="invoiceFooterItem"
                    style={{
                      float: "left",
                      width: "33.33%",
                      alignItems: "center",
                      fontFamily: "sans-serif",
                    }}
                  >
                    <span style={{ color: "#e2124f", fontWeight: 700 }}>
                      &nbsp;898-898-8787
                    </span>
                  </div>
                  <div
                    className="invoiceFooterItem"
                    style={{
                      float: "left",
                      width: "33.33%",
                      alignItems: "center",
                      fontFamily: "sans-serif",
                    }}
                  >
                    <span style={{ color: "#e2124f", fontWeight: 700 }}>
                      &nbsp;care@redcliffelabs.com
                    </span>
                  </div>
                  <div
                    className="invoiceFooterItem"
                    style={{
                      float: "right",
                      width: "33.33%",
                      alignItems: "center",
                      fontFamily: "sans-serif",
                    }}
                  >
                    <span style={{ color: "#e2124f", fontWeight: 700 }}>
                      &nbsp;www.redcliffelabs.com
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps, {})(CashRecipt);
